import { useEffect, useState } from "react";
import { useAlert } from "../../../../context/AlertContext";
import { formatDate } from "../../../../commons/FormatValue";
import { filteredCreateNewKey } from "../../../../utils/ManageArray";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import Table from "../../../../components/Table";
import ButtonLink from "../../../../components/ButtonLink";
import SearchFilter from "../../../../components/SearchFilter";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import PMPlansService from "../../../../services/pmplan.service";
import PMNosService from "../../../../services/pmno.service";

export default function CreatePM() {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [pmPlans, setPMPlans] = useState([]);
  const [pmNos, sePMNos] = useState([]);
  const searchInput = [
    {
      name: "Plan_No",
      label: "หมายเลขแผน PM",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Plan_Date",
      label: "วันที่สร้างแผน",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      findValue: { value: "Plan_No" }
    },
    {
      name: "JobType.Job_Type_Name",
      label: "ประเภทงาน",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      findValue: { value: "Plan_No" }
    },
    {
      name: "createdBy",
      label: "ผู้สร้างแผน",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      disabled: true,
      findValue: { value: "Plan_No" }
    },
    {
      name: "Customer.Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      findValue: { value: "Customer.Cus_Name" }
    },
    {
      name: "Customer.Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      size: 6,
      findValue: { value: "Customer.Cus_Code" }
    },
    {
      name: "Plan_Status",
      label: "สถานะแผน",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true
    }
  ];
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row?.rowIndex,
      sortable: true,
      width: "110px"
    },
    { name: "หมายเลข PM", selector: (row) => row?.Pm_No, minWidth: "200px" },
    {
      name: "PM/ครั้งที่",
      selector: (row) => row?.Pm_Item,
      minWidth: "120px"
    },
    {
      name: "เดือน/ครั้ง",
      selector: (row) => row?.Month_Item,
      minWidth: "120px"
    },
    {
      name: "เลขที่โครงการ",
      selector: (row) =>
        row?.PMPlan?.CustContractItem?.CustContract?.Project_No,
      minWidth: "180px"
    },
    {
      name: "เลขที่สัญญา",
      selector: (row) => row?.PMPlan?.CustContractItem?.Contract_No,
      minWidth: "180px"
    },
    {
      name: "ประเภทสัญญา",
      selector: (row) => row?.PMPlan?.CustContractItem?.Contract_Type,
      minWidth: "200px"
    },
    {
      name: "วันที่เริ่มสัญญา",
      selector: (row) =>
        row?.PMPlan?.CustContractItem?.CustContract?.Contract_Start_Date,
      format: (row) =>
        formatDate(
          row?.PMPlan?.CustContractItem?.CustContract?.Contract_Start_Date
        ),
      minWidth: "200px"
    },
    {
      name: "วันที่สิ้นสุดสัญญา",
      selector: (row) =>
        row?.PMPlan?.CustContractItem?.CustContract?.Contract_End_Date,
      format: (row) =>
        formatDate(
          row?.PMPlan?.CustContractItem?.CustContract?.Contract_End_Date
        ),
      minWidth: "200px"
    },
    {
      name: "รหัสลูกค้า/สาขา",
      selector: (row) => row?.PMPlan?.Customer?.Cus_Code,
      minWidth: "200px"
    },
    {
      name: "รหัสลูกค้า/สาขา",
      selector: (row) => row?.PMPlan?.Customer?.Cus_NumBranch,
      minWidth: "150px"
    },
    {
      name: "รหัสลูกค้า/สาขา",
      selector: (row) => row?.PMPlan?.Customer?.Cus_Name,
      minWidth: "350px"
    },
    {
      name: "รหัสสินค้า",
      selector: (row) => row?.PMPlan?.CustContractItem?.Item?.Item_Code,
      minWidth: "200px"
    },
    {
      name: "รายละเอียดสินค้า",
      selector: (row) => row?.PMPlan?.CustContractItem?.Item?.Item_Name_TH,
      minWidth: "350px"
    },
    { name: "สถานะ", selector: (row) => row?.Pm_No_Status, minWidth: "100px" },
    {
      name: "",
      selector: (row) => (
        <ButtonOptionSubmenu
          data={row}
          editButton
          state={{ edit: { name: "create" } }}
        />
      ),
      center: true,
      width: "110px"
    }
  ];

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: PMPlansService.getAllPMPlans(),
      callback: (res) => setPMPlans(res)
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: PMNosService.getAllPMNos(),
      callback: (res) => sePMNos(res)
    });
  }, []);

  return (
    <>
      <CardDisplayComponent
        header={{ title: { text: "ข้อมูลแผน PM", className: "text-center" } }}
        body={{
          element: (
            <SearchFilter
              data={pmPlans}
              inputField={searchInput}
              fieldClassName={{ actionButton: "w-auto" }}
              searchCallback={(search) =>
                setSearchValue(
                  search.some(({ value }) => value)
                    ? filteredCreateNewKey({
                        data: pmPlans,
                        search,
                        newName: "Pm_Plan_Id",
                        newValue: "Id",
                        duplicateKey: true
                      })
                    : []
                )
              }
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{
          className: "d-flex justify-content-between align-items-center",
          title: { text: "รายละเอียดแผน PM" },
          button: (
            <ButtonLink
              linkTo="create"
              stateData={{ name: "create" }}
              buttonName="สร้างแผน PM"
              buttonClass="px-5 py-2 rounded-pill"
            />
          )
        }}
        body={{
          element: (
            <Table
              data={pmNos}
              column={columns}
              searchFilter={searchValue}
              pending={loading}
              pagination
            />
          )
        }}
      />
    </>
  );
}
